const dict = {
  uk: {
    title: 'Сповіщення',
    markAllRead: 'Прочитати все',
    empty: 'Немає сповіщень',
    open: 'Відкрити',
    justNow: 'Щойно',
    minutesAgo: '{{count}} хв тому',
    hoursAgo: '{{count}} год тому',
    daysAgo: '{{count}} дн тому',
    balanceDeductionAmount: '-{{amount}} грн',
    balanceDeductionDefault: 'З вашого рахунку було знято кошти',
    balanceDeductionAck: 'Зрозуміло',
    balanceTopUpAmount: '+{{amount}} грн',
    balanceTopUpDefault: 'Ваш рахунок поповнено',
    balanceTopUpAck: 'Чудово!',
    birthdayBelatedBadge: 'Із запізненням',
    birthdayGreetingReplacement: 'Запізніле привітання',
    birthdayBelatedPrefix: 'Ти пропустив святкування, але побажання досі актуальні:',
    birthdayDone: 'Готово',
    birthdayNext: 'Далі',
    birthdayCloseAria: 'Закрити',
    rotateDeviceTitle: 'Будь ласка, переверніть телефон',
    rotateDeviceMessage: 'Урок проходить у горизонтальному режимі. Поверніть пристрій, щоб продовжити.',
    loadingEllipsis: 'Завантаження…',
  },
  en: {
    title: 'Notifications',
    markAllRead: 'Mark all read',
    empty: 'No notifications',
    open: 'Open',
    justNow: 'Just now',
    minutesAgo: '{{count}} min ago',
    hoursAgo: '{{count}} h ago',
    daysAgo: '{{count}} d ago',
    balanceDeductionAmount: '-{{amount}} UAH',
    balanceDeductionDefault: 'Funds have been deducted from your account',
    balanceDeductionAck: 'Got it',
    balanceTopUpAmount: '+{{amount}} UAH',
    balanceTopUpDefault: 'Your account has been topped up',
    balanceTopUpAck: 'Great!',
    birthdayBelatedBadge: 'Belated',
    birthdayGreetingReplacement: 'Belated greetings',
    birthdayBelatedPrefix: 'You missed the celebration, but the wishes still stand:',
    birthdayDone: 'Done',
    birthdayNext: 'Next',
    birthdayCloseAria: 'Close',
    rotateDeviceTitle: 'Please rotate your phone',
    rotateDeviceMessage: 'The lesson runs in landscape mode. Rotate your device to continue.',
    loadingEllipsis: 'Loading…',
  },
};

export default dict;
